import { BeneficiaryAndInsuredPerson, CustomerFields } from '../PersonsFields'

export const CustomerStep = () => {
  return (
    <>
      <CustomerFields isEditable />
      <BeneficiaryAndInsuredPerson />
    </>
  )
}
